import React from 'react';
import PropTypes from 'prop-types';
import CategoryLabel from "./CategoriesLabel";
import CategoryLink from "./CategoryLink";

function CategoryItem(_ref) {
  var label = _ref.label,
      labelExtra = _ref.labelExtra,
      linkComponent = _ref.linkComponent,
      href = _ref.href,
      depth = _ref.depth,
      _onCategoryClick = _ref.onCategoryClick,
      _ref$external = _ref.external,
      external = _ref$external === void 0 ? false : _ref$external,
      _ref$sponsored = _ref.sponsored,
      sponsored = _ref$sponsored === void 0 ? false : _ref$sponsored;
  var trackLabel = labelExtra ? "".concat(label, " (").concat(labelExtra, ")") : label;
  return /*#__PURE__*/React.createElement(CategoryLink, {
    linkComponent: linkComponent,
    href: href,
    depth: depth,
    isHeader: depth === 0,
    onCategoryClick: function onCategoryClick() {
      return _onCategoryClick(trackLabel);
    },
    isExternalLink: external,
    isSponsored: sponsored
  }, /*#__PURE__*/React.createElement(CategoryLabel, {
    label: label,
    labelExtra: labelExtra,
    external: external
  }));
}

CategoryItem.propTypes = process.env.NODE_ENV !== "production" ? {
  label: PropTypes.string.isRequired,
  labelExtra: PropTypes.string,
  linkComponent: PropTypes.node,
  href: PropTypes.string.isRequired,
  depth: PropTypes.number.isRequired,
  onCategoryClick: PropTypes.func.isRequired,
  external: PropTypes.bool,
  sponsored: PropTypes.bool
} : {};
export default CategoryItem;
//# sourceMappingURL=CategoryItem.js.map